<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`设备材料检测详情`"
    width="1440px"
    height="100vh"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm', 'areaTreeData')"
  >
    <el-form v-loading="detailLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item label="委托编号" prop="reportCode">
            <el-input disabled v-model="editForm.reportCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="委托单位" prop="client">
            <el-input disabled v-model="editForm.client" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工程名称" prop="projectName">
            <el-input disabled v-model="editForm.projectName" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="委托日期" prop="wtDate">
            <el-date-picker
              disabled
              v-model="editForm.wtDate"
              type="date"
              placeholder="请选择"
              value-format="yyyy.MM.dd"
              format="yyyy.MM.dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="委托人" prop="sfcn">
            <el-input disabled v-model="editForm.sfcn" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="sfcp">
            <el-input disabled v-model="editForm.sfcp" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="委托人地址">
            <el-row :gutter="10" type="flex" style="flex-wrap: wrap">
              <el-col :span="6">
                <el-select disabled v-model="editForm.sfca1" placeholder="请选择" clearable>
                  <el-option v-for="item in areaTreeData" :key="item.id" :label="item.text" :value="item.text"></el-option>
                </el-select>
              </el-col>
              <el-col :span="6">
                <el-select disabled v-model="editForm.sfca2" placeholder="请选择" clearable>
                  <el-option v-for="item in cityTreeData" :key="item.id" :label="item.text" :value="item.text"></el-option>
                </el-select>
              </el-col>
              <el-col :span="6">
                <el-select disabled v-model="editForm.sfca3" placeholder="请选择" clearable>
                  <el-option v-for="item in districtTreeData" :key="item.id" :label="item.text" :value="item.text"></el-option>
                </el-select>
              </el-col>
              <el-col :span="6">
                <el-input disabled v-model="editForm.sfca" placeholder="请输入" clearable></el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检测类别" prop="testType">
            <el-radio-group disabled v-model="editForm.testType">
              <el-radio v-for="item in testTypeOptions" :key="item.code" :label="item.code">{{ item.name }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-radio-group v-model="sampleInfoType" style="margin-left: 40px; margin-bottom: 14px">
          <el-radio-button label="委托样品信息">委托协议书样品信息</el-radio-button>
          <el-radio-button label="检测样品信息"></el-radio-button>
        </el-radio-group>

        <div v-if="editForm.sampleInfoList && editForm.sampleInfoList.length > 0" style="width: calc(100% - 80px)">
          <table v-show="sampleInfoType === '委托样品信息'" class="word-table">
            <tr>
              <td width="25%">样品名称</td>
              <td width="60%" class="label">检测项目</td>
              <td width="15%" class="label">是否外委</td>
            </tr>

            <template v-for="(item, index) in entrustSampleData">
              <tr :key="index">
                <td width="25%" :rowspan="item.nodes.length + 1">{{ item.name }}</td>
              </tr>
              <tr v-for="sample in item.nodes" :key="sample.code">
                <td width="60%" class="align-Left">
                  <el-checkbox disabled v-model="sample.checked">{{ sample.name }}</el-checkbox>
                </td>
                <td width="15%">
                  <el-radio-group disabled v-model="sample.isWw" size="mini">
                    <el-radio-button label="是"></el-radio-button>
                    <el-radio-button label="否"></el-radio-button>
                    <el-radio-button label="">空</el-radio-button>
                  </el-radio-group>
                </td>
              </tr>
            </template>
          </table>

          <table v-show="sampleInfoType === '检测样品信息'" class="word-table">
            <tr>
              <td width="18%" class="label">样品名称</td>
              <td width="12%" class="label">试件名称</td>
              <td width="6%" class="label">规格型号</td>
              <td width="8%" class="label">数量</td>
              <td width="20%" class="label">生产厂家</td>
            </tr>
            <tr v-for="(item, index) in editForm.sampleInfoList" :key="index">
              <td>{{ item.sampleBelong }}</td>
              <td>{{ item.sampleName }}</td>
              <td>{{ item.model }}</td>
              <td>{{ item.cnt }}</td>
              <td>{{ item.manufacturer }}</td>
            </tr>
          </table>
          <table v-show="sampleInfoType === '检测样品信息'" class="word-table">
            <tr>
              <td width="20%">
                <span class="label table-required">检测项目</span>
              </td>
              <td width="80%" class="label"><span class="label table-required">依据的标准名称及编号(含年号)</span></td>
            </tr>
            <tr v-for="(item, index) in editForm.basisTotalList" :key="index">
              <td>
                <span>{{ item.itemName }}</span>
              </td>
              <td>{{ item.basisName }}</td>
            </tr>
          </table>
        </div>

        <el-col :span="12">
          <el-form-item label="是否接受分包至其他有资质的检测机构" prop="isSbct" label-width="300px">
            <el-radio-group disabled v-model="editForm.isSbct">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出具报告类型" prop="reportType">
            <el-checkbox-group disabled v-model="editForm.reportType">
              <el-checkbox :label="0" disabled>合格样品报告</el-checkbox>
              <el-checkbox :label="1">不合格样品报告</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="样品处理方式" prop="sampleDealWay">
            <el-radio-group disabled v-model="editForm.sampleDealWay">
              <el-radio :label="0">自取</el-radio>
              <el-radio :label="1">样品所有权转归受托方，并全权处置</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报告领取方式" prop="deliveryType">
            <el-radio-group disabled v-model="editForm.deliveryType">
              <el-radio :label="0">自取</el-radio>
              <el-radio :label="1">邮寄（到付）</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="特殊说明" prop="note">
            <el-input disabled type="textarea" v-model="editForm.note" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="是否邮寄" prop="isIvDdeliver">
            <div class="break-radio">
              <el-radio-group disabled v-model="editForm.isIvDdeliver">
                <div class="radio-line">
                  <el-radio :label="1">是</el-radio>
                  <el-input
                    v-model="editForm.ivDdeliveryAddress"
                    placeholder="请输入邮寄地址"
                    style="width: 500px"
                    clearable
                  ></el-input>
                </div>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="样品状态描述" prop="scac">
            <el-select disabled v-model="editForm.scac" placeholder="请选择" style="margin-bottom: 10px">
              <el-option label="完好" value="完好"></el-option>
              <el-option label="完好无损" value="完好无损"></el-option>
              <el-option label="新品完整" value="新品完整"></el-option>
              <el-option label="外观无异常" value="外观无异常"></el-option>
              <el-option label="外观异常" value="外观异常"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="特殊说明" prop="noteInner">
            <el-input
              disabled
              type="textarea"
              v-model="editForm.noteInner"
              placeholder="请输入（供内部查看）"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="地址" prop="testAddress">
            <el-checkbox-group disabled v-model="editForm.testAddress">
              <el-checkbox v-for="item in addressOptions" :key="item.code" :label="item.name"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <div class="footer-form-item">
        <div class="label">工程类型</div>
        <el-select disabled v-model="editForm.etmtType" placeholder="请选择">
          <el-option v-for="item in etmtTypeOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
        </el-select>
      </div>

      <div>
        <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      </div>
    </div>
  </drag-dialog>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import sampleListXL from '../../experiment/components/SampleListXL';
import sampleListBD from '../../experiment/components/SampleListBD';

import { getDictsByCode, getAreaTree } from '@/api/system';
import { getTotEntrustment } from '@/api/entrust';
import { getRoleUserList } from '@/api/user';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      editForm: {
        id: null,
        reportCode: '',
        client: '', // 委托单位
        projectName: '', // 工程名称
        totTime: '',
        wtDate: '',
        payOrg: '', // 付款单位
        sfcn: '', // 送检人
        sfcp: '', // 联系电话
        sfca1: '', // 送检人地址部分1
        sfca2: '', // 送检人地址部分2
        sfca3: '', // 送检人地址部分3
        sfca: '', // 送检人地址部分4
        testType: '', // 检测类别
        isSbct: 0, // 是否接受分包至其他有资质的检测机构
        reportType: [0], // 出具报告类型
        sampleDealWay: null, // 样品处理方式
        deliveryType: null, // 报告领取方式
        serviceType: null, // 服务类型
        note: '', // 特殊说明
        isIvDdeliver: null, // 是否邮寄
        ivDdeliveryAddress: '', // 邮寄地址
        sendDate: null, // 送样日期
        noteInner: '', // 内部特殊说明
        etmtType: 'petmt_type_xl', // 工程类型
        scac: '',
        testAddress: [], // 地址
        sampleInfoList: [],
        td: '',
        wd: '',
        testedTime: '',
        testedTimeCn: '',
        testedBy: '',
        auditedBy: '',
        approvedBy: '',
        gbDate: '',
        signDate: '',
        etmtSync: '',
        sampleCnt: '',
        etmtSync: ''
      },
      etmtTypeOptions: [],
      testTypeOptions: [],
      areaTreeData: [],
      experimenterOptions: [],
      addressOptions: [],
      auditorOptions: [],
      approverOptions: [],
      rules: {
        reportCode: [{ required: true, message: '请输入', trigger: 'blur' }],
        client: [{ required: true, message: '请输入', trigger: 'blur' }],
        projectName: [{ required: true, message: '请输入', trigger: 'blur' }],
        payOrg: [{ required: true, message: '请输入', trigger: 'blur' }],
        sfcn: [{ required: true, message: '请输入', trigger: 'blur' }],
        sfcp: [{ required: true, message: '请输入', trigger: 'blur' }],
        testType: [{ required: true, message: '请选择', trigger: 'change' }],
        reportType: [{ required: true, message: '请选择', trigger: 'change' }],
        sampleDealWay: [{ required: true, message: '请选择', trigger: 'change' }],
        deliveryType: [{ required: true, message: '请选择', trigger: 'change' }],
        serviceType: [{ required: true, message: '请选择', trigger: 'change' }],
        isIvDdeliver: [{ required: true, message: '请选择', trigger: 'change' }],
        sendDate: [{ required: true, message: '请选择', trigger: 'change' }],
        scac: [{ required: true, message: '请选择', trigger: 'change' }],
        testAddress: [{ required: true, message: '请选择', trigger: 'change' }],
        testedBy: [{ required: true, message: '请选择', trigger: 'change' }],
        auditedBy: [{ required: true, message: '请选择', trigger: 'change' }],
        approvedBy: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      detailLoading: false,
      submitLoading: false,
      sampleInfoType: '委托样品信息',
      entrustSampleData: []
    };
  },
  computed: {
    cityTreeData({ editForm, areaTreeData }) {
      const parent = areaTreeData.filter(item => item.text == editForm.sfca1)?.[0];
      return parent?.nodes || [];
    },
    districtTreeData({ editForm, cityTreeData }) {
      const parent = cityTreeData.filter(item => item.text == editForm.sfca2)?.[0];
      return parent?.nodes || [];
    }
  },
  watch: {
    async visible(val) {
      if (val) {
        await this.getDictsByCode('petmt_type', 'etmtTypeOptions');
        await this.getDictsByCode('address_entrust', 'addressOptions');
        await this.getDictsByCode('test_type', 'testTypeOptions');

        const env = process.env.VUE_APP_BASE_ENV;

        if (env == 'dev') {
          // 测试环境
          // 获取实验室人员列表
          this.experimenterOptions = await this.getRoleUserList('8a8084828f4c6e3a018f50dfdafe03fc');
          // 获取报告审核人
          this.auditorOptions = await this.getRoleUserList('2c942eb49445204c01944566c1c20081');
          // 获取报告批准人
          this.approverOptions = await this.getRoleUserList('2c942eb49445204c0194456745340082');
        } else {
          // 获取实验室人员列表
          this.experimenterOptions = await this.getRoleUserList('2c942eb49768bf2e019786b4d687032b');
          // 获取报告审核人
          this.auditorOptions = await this.getRoleUserList('2c942eb496ce0b630196e7ba2d060667');
          // 获取报告批准人
          this.approverOptions = await this.getRoleUserList('2c942eb4973fa01f019743157a910205');
        }

        if (this.activeId) {
          this.getDetailData();
        }

        if (this.areaTreeData.length == 0) {
          this.getAreaTree();
        }
      }
    },
    'editForm.isIvDdeliver'(newVal) {
      if (newVal === 1) {
        this.editForm.deliveryType = 1;
      } else {
        this.editForm.deliveryType = 0;
      }
    },

    'editForm.deliveryType'(newVal) {
      if (newVal === 1) {
        this.editForm.isIvDdeliver = 1;
      } else {
        this.editForm.isIvDdeliver = 0;
      }
    }
  },
  methods: {
    async getDetailData() {
      this.detailLoading = true;
      // todo 其它委托类型
      try {
        const { data } = await getTotEntrustment({ id: this.activeId });
        const reportType = data.reportType == 0 ? [0] : [0, 1];
        this.editForm = { ...this.editForm, ...data, reportType };

        // 回显委托协议书样品信息
        if (data.sampleOption) {
          let entrustSampleData = [];
          if (this.editForm.etmtType == 'petmt_type_xl' || this.editForm.etmtType == 'petmt_type_x') {
            entrustSampleData = cloneDeep(sampleListXL);
          } else {
            entrustSampleData = cloneDeep(sampleListBD);
          }

          const sampleOption = JSON.parse(data.sampleOption);
          entrustSampleData.forEach(item => {
            item.nodes.forEach(node => {
              const sample = sampleOption.find(sample => node.code == sample.code);
              node.checked = sample?.checked ?? false;
              node.isWw = sample?.isWw ?? '';
            });
          });
          this.entrustSampleData = entrustSampleData;
        } else {
          if (this.editForm.etmtType == 'petmt_type_xl' || this.editForm.etmtType == 'petmt_type_x') {
            this.entrustSampleData = cloneDeep(sampleListXL);
          } else {
            this.entrustSampleData = cloneDeep(sampleListBD);
          }
        }

        this.templateUrl = this.etmtTypeOptions.filter(item => item.code == this.editForm.etmtType)[0].value;

        this.editForm.testAddress = data.testAddress.split(',');

        this.$nextTick(() => {
          this.$refs.editForm.clearValidate();
        });
      } finally {
        this.detailLoading = false;
      }
    },
    // 获取字典
    async getDictsByCode(code, dataType) {
      const { data } = await getDictsByCode({ code });
      this[dataType] = data;
    },
    // 省市区树形
    async getAreaTree() {
      const { data } = await getAreaTree();
      this.areaTreeData = data || [];
    },
    // 根据角色ID获取用户列表
    async getRoleUserList(roleId) {
      const { data } = await getRoleUserList({ pageNum: 1, pageSize: 9999, select: 1, roleId });
      return data.list || [];
    }
  },

  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.el-button--mini.is-circle {
  padding: 5px;
}

.word-table {
  margin-right: 40px;
  margin-left: 40px;
}

.break-radio {
  .el-radio {
    margin-bottom: 10px;
  }
  .radio-line {
    display: flex;
    align-items: center;
    .el-radio {
      margin-bottom: 0;
    }
  }
}
</style>
